<template>

  <v-container
    v-if="invoice && invoices && reservations && contracts && suppliers && clients && invoice_channels && invoice_types && countries"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title>Factură</v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text>
        <v-row no-gutters>


          <v-col cols="12" md="6">
            <v-row no-gutters>
              <v-col cols="12">
                <div class="subtitle-1 font-weight-black ma-1">Furnizor</div>
              </v-col>
              <v-col cols="7">
                <v-autocomplete v-model="supplier" label="Caută" class="ma-1" :items="suppliers.data" item-text="contact.name" return-object outlined dense hide-details/>
              </v-col>
              <v-col cols="5">
                <div class="ma-1">
                  <v-btn height="40" color="primary" depressed block @click="fillSupplier">
                    Completează
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <v-card outlined class="ma-1 pa-1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.name" label="Nume" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.cui" label="CUI" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.reg_com" label="Nr. Reg. Comercial" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.bank.name" label="Bancă" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.bank.iban" label="IBAN" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.bank.currency" label="Valută" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.address.street" label="Adresă" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.address.city" label="Oraș" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.supplier.address.region" label="Județ" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="invoice.supplier.address.country" :items="countries" label="Țară" class="ma-1" outlined dense hide-details/>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>


          <v-col cols="12" md="6">
            <v-row no-gutters>
              <v-col cols="12">
                <div class="subtitle-1 font-weight-black ma-1">Client</div>
              </v-col>
              <v-col cols="7">
                <v-autocomplete v-model="client" label="Caută" class="ma-1" :items="clients.data" item-text="contact.name" return-object outlined dense hide-details/>
              </v-col>
              <v-col cols="5">
                <div class="ma-1">
                  <v-btn height="40" color="primary" depressed block @click="fillClient">
                    Completează
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <v-card outlined class="ma-1 pa-1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.name" label="Nume" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.cui" label="CUI" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.reg_com" label="Nr. Reg. Comercial" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.bank.name" label="Bancă" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.bank.iban" label="IBAN" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.bank.currency" label="Valută" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.address.street" label="Adresă" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.address.city" label="Oraș" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="invoice.client.address.region" label="Județ" class="ma-1" outlined dense hide-details/>
                    </v-col>
                    <v-col cols="12">
                      <v-select v-model="invoice.client.address.country" :items="countries" label="Țară" class="ma-1" outlined dense hide-details/>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="invoice.reference_number" label="Referintă" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu v-model="menu_issue_date" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="invoice.issue_date" v-on="on" label="Data emiterii" class="ma-1" readonly outlined dense hide-details/>
              </template>
              <v-date-picker v-model="invoice.issue_date" @input="menu_issue_date = false"/>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-select v-model="invoice.channel" :items="invoice_channels" label="Canal" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="invoice.comments" label="Observatii" class="ma-1" outlined dense hide-details/>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Valoare</div>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="invoice.net_value" label="Valoare netă" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="invoice.vat_percentage" label="Valoare TVA (%)" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="invoice.vat_value" label="Valoare cu TVA inclus" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-model="invoice.total_value" label="Valoare totală" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="invoice.exchange_rate" label="Rată de schimb valutar" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="invoice.currency" label="Valută" class="ma-1" outlined dense hide-details/>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Tip</div>
          </v-col>
          <v-col cols="12">
            <v-select v-model="invoice.type" :items="invoice_types" label="Tip" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-row no-gutters v-if="invoice.type!=='fiscal'">
            <v-col cols="12" v-for="(rinvoice, index) in invoice.invoices" :key="`rinvoice_${index}`">
              <v-card class="ma-1" outlined>
                <v-card-text class="pa-1">
                  <v-row no-gutters>
                    <v-col cols="12" md="11">
                      <v-row no-gutters>
                        <v-col cols="12" md="6">
                          <v-autocomplete v-model="rinvoice.id" :items="invoices" class="ma-1" label="Factura" outlined dense hide-details/>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="rinvoice.pivot.amount" class="ma-1" type="number" label="Valoare" outlined dense hide-details/>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="ma-1">
                        <v-btn height="40" color="delete white--text" depressed block @click="removeInvoice(rinvoice)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn dark color="create" depressed class="ma-1" @click="addInvoice">
                <v-icon left>mdi-plus</v-icon>
                Adaugă
              </v-btn>
            </v-col>
          </v-row>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Termene de plată</div>
          </v-col>
          <v-col cols="12" v-for="(installment, index) in invoice.due_dates" :key="`installment_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-menu v-model="installment.menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="installment.date" v-on="on" label="Dată" class="ma-1" readonly outlined dense hide-details/>
                          </template>
                          <v-date-picker v-model="installment.date" @input="installment.menu = false"/>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="installment.amount" class="ma-1" type="number" label="Valoare" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeInstallment(installment)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn dark color="create" depressed class="ma-1" @click="addInstallment">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Rezervari asociate</div>
          </v-col>
          <v-col cols="12" v-for="(reservation, index) in invoice.reservations" :key="`reservation_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-autocomplete v-model="reservation.id" :items="reservations" class="ma-1" label="Rezervare" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="reservation.pivot.amount" class="ma-1" type="number" label="Valoare" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeReservation(reservation)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn dark color="create" depressed class="ma-1" @click="addReservation">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Contracte asociate</div>
          </v-col>
          <v-col cols="12" v-for="(contract, index) in invoice.contracts" :key="`contract_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="12" md="11">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-autocomplete v-model="contract.id" :items="contracts" class="ma-1" label="Contract" outlined dense hide-details/>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="contract.pivot.amount" class="ma-1" type="number" label="Valoare" outlined dense hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeContract(contract)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn dark color="create" depressed class="ma-1" @click="addContract">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </v-col>


          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Fișiere</div>
          </v-col>
          <v-col cols="12">
            <v-file-input v-model="files" accept="application/pdf" label="Adăuga" class="ma-1" @change="onFileChange($event)" multiple small-chips show-size outlined dense hide-details/>
          </v-col>
          <v-col cols="12" v-for="(file, index) in files_64" :key="`file64_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="11">
                    <v-text-field v-model="file.name" label="Nume" class="ma-1" outlined dense hide-details/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeFile(file)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" v-for="(file, index) in invoice.files" :key="`file_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="10">
                    <v-text-field v-model="file.properties.name" label="Nume" class="ma-1" outlined dense hide-details readonly/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="primary" :href="file.url" target="_blank" dark depressed block>
                        <v-icon>
                          mdi-download
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="destroyFile(file, index)" :loading="file_loading[index]" :disabled="file_loading[index]">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="invoice.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import default_invoice from '@/defaults/default-invoice';
  import invoice_repository from '@/repositories/invoice-repository';
  import reservation_repository from '@/repositories/reservation-repository';
  import contract_repository from '@/repositories/contract-repository';
  import config_repository from '@/repositories/config-repository';
  import supplier_repository from '@/repositories/supplier-repository';
  import media_repository from '@/repositories/media-repository';

  export default {
    data: () => ({
      invoice: null,
      invoice_channels: null,
      invoice_types: null,
      reservations: null,
      invoices: null,
      contracts: null,
      countries: null,
      suppliers: null,
      clients: null,

      supplier: null,
      client: null,

      menu_issue_date: false,

      files: null,
      files_64: null,
      file_loading: [],

      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    async created() {
      this.invoice = this.$route.params.invoice === 'create' ? _.cloneDeep(default_invoice) : await invoice_repository.getInvoice(this.$route.params.invoice);
      reservation_repository.getReservations(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, true).then(r => this.reservations = r);
      invoice_repository.getInvoices(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {type: 'fiscal', dropdown: true}).then(r => this.invoices = r);
      contract_repository.getContracts(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true}).then(r => this.contracts = r);
      supplier_repository.getSuppliers(null, {page: 1, size: Number.MAX_SAFE_INTEGER}).then(r => this.suppliers = this.clients = r);
      config_repository.getInvoiceChannels().then(r => this.invoice_channels = r);
      config_repository.getInvoiceTypes().then(r => this.invoice_types = r);
      config_repository.getCountries().then(r => this.countries = r);
    },

    watch: {
      'invoice.supplier': {
        handler: function () {
          this.invoice.supplier_id = null;
        },
        deep: true
      },
      'invoice.client': {
        handler: function () {
          this.invoice.client_id = null;
        },
        deep: true
      }
    },

    methods: {
      async save() {
        try {
          this.saving = true;

          if (this.$route.params.invoice === 'create') {
            this.invoice = await invoice_repository.saveInvoice(this.invoice);
            await media_repository.saveMedia(this.invoice.id, 'invoices', {data: this.files_64});
            await this.$store.dispatch('alert/success', 'Factura a fost creata.');
            await this.$router.push(`/invoices/${this.invoice.id}`);
          } else {
            await media_repository.saveMedia(this.invoice.id, 'invoices', {data: this.files_64});
            this.invoice = await invoice_repository.saveInvoice(this.invoice);
            await this.$store.dispatch('alert/success', 'Factura a fost salvata.');
          }

        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
          this.files = null;
          this.files_64 = null;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await invoice_repository.destroyInvoice(this.invoice);
          await this.$router.push(`/invoices`);
          await this.$store.dispatch('alert/success', 'Success');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      async destroyFile(file, index) {
        try {
          this.$set(this.file_loading, index, true);
          await media_repository.deleteMedia(this.invoice.id, 'invoices', file);
          this.invoice = await invoice_repository.getInvoice(this.invoice.id);
          await this.$store.dispatch('alert/success', 'Documentul a fost sters!');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.$set(this.file_loading, index, false);
        }
      },

      fillSupplier() {
        if (!this.supplier) return;
        this.invoice.supplier_id = this.supplier.contact.id;
        this.invoice.supplier.name = this.supplier.contact.name;
        this.invoice.supplier.cui = this.supplier.financial.cui;
        this.invoice.supplier.reg_com = this.supplier.financial.reg_com;
        this.invoice.supplier.bank.name = this.supplier.financial.bank.name;
        this.invoice.supplier.bank.iban = this.supplier.financial.bank.iban;
        this.invoice.supplier.bank.currency = this.supplier.financial.bank.currency;
        this.invoice.supplier.address.street = this.supplier.contact.address;
        this.invoice.supplier.address.city = this.supplier.contact.region;
        this.invoice.supplier.address.region = this.supplier.contact.region;
        this.invoice.supplier.address.country = this.supplier.contact.country;
        this.supplier = null;
      },

      fillClient() {
        if (!this.client) return;
        this.invoice.client_id = this.client.contact.id;
        this.invoice.client.name = this.client.contact.name;
        this.invoice.client.cui = this.client.financial.cui;
        this.invoice.client.reg_com = this.client.financial.reg_com;
        this.invoice.client.bank.name = this.client.financial.bank.name;
        this.invoice.client.bank.iban = this.client.financial.bank.iban;
        this.invoice.client.bank.currency = this.client.financial.bank.currency;
        this.invoice.client.address.street = this.client.contact.address;
        this.invoice.client.address.city = this.client.contact.region;
        this.invoice.client.address.region = this.client.contact.region;
        this.invoice.client.address.country = this.client.contact.country;
        this.client = null;
      },

      addInvoice() {
        this.invoice.invoices.push({date: null, pivot: {amount: null}});
      },

      removeInvoice(invoice) {
        this.invoice.invoices.splice(this.invoice.invoices.indexOf(invoice), 1);
      },

      addInstallment() {
        this.invoice.due_dates.push({date: null, amount: null});
      },

      removeInstallment(installment) {
        this.invoice.due_dates.splice(this.invoice.due_dates.indexOf(installment), 1);
      },

      addReservation() {
        this.invoice.reservations.push({id: null, pivot: {amount: null}});
      },

      removeReservation(reservation) {
        this.invoice.reservations.splice(this.invoice.reservations.indexOf(reservation), 1);
      },

      addContract() {
        this.invoice.contracts.push({id: null, pivot: {amount: null}});
      },

      removeContract(contract) {
        this.invoice.contracts.splice(this.invoice.contracts.indexOf(contract), 1);
      },

      removeFile(file) {
        this.files.splice(this.files.indexOf(file), 1);
        this.files_64.splice(this.files_64.indexOf(file), 1);
      },

      onFileChange(files) {
        this.files_64 = [];
        for (let file of files) {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            this.files_64.push({
              data: fileReader.result,
              name: file.name
            });
          });
          fileReader.readAsDataURL(file);
        }
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }

    }


  }

</script>